export const EDIT_STEP_HISTORICAL_TYPE_VALUE = "EditStep";
export const MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE = "MoveToProgressStep";
export const CASE_DECISION_HISTORICAL_TYPE_VALUE = "CaseDecision";
export const DOCUMENT_EDIT_HISTORICAL_TYPE_VALUE = "DocumentEdit";
export const REPORT_GENERATION_HISTORICAL_TYPE_VALUE = "ReportGeneration";

export const HISTORICAL_TYPE_VALUES = {
  [EDIT_STEP_HISTORICAL_TYPE_VALUE]: EDIT_STEP_HISTORICAL_TYPE_VALUE,
  [MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE]: MOVE_TO_PROGRESS_STEP_HISTORICAL_TYPE_VALUE,
  [CASE_DECISION_HISTORICAL_TYPE_VALUE]: CASE_DECISION_HISTORICAL_TYPE_VALUE,
  [DOCUMENT_EDIT_HISTORICAL_TYPE_VALUE]: DOCUMENT_EDIT_HISTORICAL_TYPE_VALUE,
  [REPORT_GENERATION_HISTORICAL_TYPE_VALUE]: REPORT_GENERATION_HISTORICAL_TYPE_VALUE,
};
